// form name
export const FLEET_CONTACT_US_FORM = 'fleetServicesContactUsForm'
export const CONTACT_US_FORM = 'contactUsForm'

// comment field max length
export const MAX_COMMENT_LENGTH = 2000

// fields names
export const NAME_FIELD = 'name'
export const PHONE_FIELD = 'phoneNumber'
export const EMAIL_FIELD = 'email'
export const ZIP_CODE_FIELD = 'zipCode'
export const SUBJECT_FIELD = 'subject'
export const COMMENTS_FIELD = 'comments'
export const FUTURE_CONTACT = 'futureContact'
export const DESTINATION_EMAIL = 'destinationEmail'

export const ADDRESS_FIELD = 'address'
export const BEST_TIME_TO_CALL_FIELD = 'bestTimeToCall'
export const CITY_FIELD = 'city'
export const PHONE_EXTENSION_FIELD = 'ext'
export const NUMBERS_OF_VEHICLES_IN_FLEET_FIELD = 'numberofVehiclesinFleet'
export const STATE_FIELD = 'state'
export const TYPE_OF_COMPANY_FIELD = 'typeofCompany'
export const STORE_LOCATION = 'storeNumber'
export const DATE_OF_SERVICE = 'dateOfService'
export const INVOICE_OR_ESTIMATE = 'invoiceOrEstimate'


// validation error messages
export const NAME_VALIDATION_MESSAGE = 'Your Name may only consist of up to 20 characters.'
export const PHONE_VALIDATION_MESSAGE = 'Please enter a valid phone number.'
export const EMAIL_VALIDATION_MESSAGE = 'Please enter a valid email address.'
export const ZIP_CODE_VALIDATION_MESSAGE = 'Please enter a valid zip code.'
export const STORE_LOCATION_VALIDATION_MESSAGE = 'Please choose a store.'
export const SUBJECT_VALIDATION_MESSAGE = 'Please select a subject.'
export const REQUIRED_FIELDS_MESSAGE = 'All required fields are not filled'
export const COMMENTS_VALIDATION_MESSAGE = 'Please enter your comment.'

// subject fields display names
export const STORE_EXPERIENCE_NAME = 'Store Experience'
export const GENERAL_COMMENTS_NAME = 'General Comments/Inquiry'


// subject fields values
export const GENERAL_COMMENTS_VALUE = 'FranchiseContactUs@tbccorp.com'
export const STORE_EXPERIENCE_VALUE = 'FranchiseContactUs@tbccorp.com'

// subject fields mapping
export const SUBJECT_FIELDS = {
  [GENERAL_COMMENTS_NAME]: GENERAL_COMMENTS_VALUE,
  [STORE_EXPERIENCE_NAME]: STORE_EXPERIENCE_VALUE
}

// subject field values map
export const SUBJECT_EMAILS_OPTIONS = [
  { label: GENERAL_COMMENTS_NAME, value: GENERAL_COMMENTS_VALUE },
  { label: STORE_EXPERIENCE_NAME, value: STORE_EXPERIENCE_VALUE }
]

// contact form subject field values map
export const CONTACT_SUBJECT_EMAILS_OPTIONS = [
  { label: GENERAL_COMMENTS_NAME, value: GENERAL_COMMENTS_NAME },
  { label: STORE_EXPERIENCE_NAME, value: STORE_EXPERIENCE_NAME }
]

// fleet services default values
export const FLEET_DEFAULTS = {
  SUBJECT_FIELD: 'Fleet Services Contact Form',
  COMMENTS_FIELD: 'Fleet Services Contact Form',
  FUTURE_CONTACT: true
}

// async action constants
export const description = 'Your information has been sent.'
export const confirmButtonText = 'Close'

// legend titles
export const PERSONAL_INFORMATION = 'Personal Information'
export const SERVICE_DETAILS = 'Service Details'
export const CONTACT_DETAILS = 'Contact Details'

// form hint
export const SERVICE_DETAILS_HINT = 'If you are writing about service you received at one of our locations, please fill out the following fields.'
export const SERVICE_DETAILS_HINT_ID = 'service-details-hint'

// required fields
export const CONTACT_REQUIRED_FIELDS = [NAME_FIELD, PHONE_FIELD, EMAIL_FIELD, SUBJECT_FIELD, COMMENTS_FIELD]
export const FLEET_REQUIRED_FIELDS = [NAME_FIELD, PHONE_FIELD, EMAIL_FIELD]

// ReCaptcha
export const RECAPTCHA_ERROR_MESSAGE = 'Please confirm you are not a robot.'

// OG Title and Description
export const FLEET_SERVICES_OG_TITLE = 'Big O Tires Fleet Maintenance Services'
export const FLEET_SERVICES_OG_DESCRIPTION = 'Ensure your fleet operates seamlessly with Big O Tires\' comprehensive fleet services and maintenance. Whether it\'s oil changes or tire rotations, we\'ve got you covered.'
